import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { ConsultasSqlApi, EncuestaRespuestasApi, EncuestaRespuestasDetalleApi, EncuestasApi, SectorApi, SucursalApi, Turno, TurnoApi } from 'app/shared/lb-sdk';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-listado-encuestas',
  templateUrl: './listado-encuestas.component.html',
  styleUrls: ['./listado-encuestas.component.css']
})
export class ListadoEncuestasComponent implements OnInit {
  loginOk = false;
  tipoEncuestas: any[] = [];
  fechaDesde: string | null = null;
  fechaHasta: string | null = null;
  mostrarSpinner = false;
  turnos = [];
  sucursalesDB = []
  idsucursalseleccionada = 0;

  isActive = true;
  sucursalFiltro = 0;
  turnosLlamados: Array<Turno> = [];
  // ultimoLlamado: Turno = new Turno({ idTurno: -1, numerador: -1, fecha: null, fechaAnulacion: null, horaEntrega: null, horaLlamado: null, horaPedido: null, idPuesto: 1, observaciones: null });
  blink: boolean = false;
  sectores: any;
  listaPreguntas: any[] = [];
  listaEncuestas: any[] = [];
  tipoEncuestaSeleccionada;
  constructor(private toastr: ToastrService, private sucursalApi: SucursalApi, private encuestasApi: EncuestasApi, private encuestRespuestaApi: EncuestaRespuestasApi, private encuestaRespuestaDetalleApi: EncuestaRespuestasDetalleApi, private consultaSql: ConsultasSqlApi, private spinner: NgxSpinnerService, public authService: AuthService, private router: Router) {


  }
  ngOnInit(): void {

  

    this.fechaHasta = new Date().toISOString().slice(0, 19).replace('T', ' ');
    this.fechaDesde = new Date("2020-11-22 12:18:05").toISOString().slice(0, 19).replace('T', ' ');


    let hoy = new Date();

    let mes = hoy.getMonth() + 1;
    let dia = hoy.getDate();
    let anio = hoy.getFullYear();
    this.fechaDesde = `${anio}-${mes < 10 ? '0' : ''}${mes}-${dia < 10 ? '0' : ''}${dia}`;;
    this.fechaHasta = this.fechaDesde
    debugger;
    this.encuestasApi.find()
      .subscribe((respuesta: any) => {
        debugger;
        console.log(respuesta)

        this.tipoEncuestas = respuesta;


      })
    this.sucursalApi.find()
      .subscribe(respuesta => {
        this.sucursalesDB = respuesta
        this.sucursalesDB = [{ idsucursal: 0, nombre: 'Todos' }, ...respuesta];
      })

  }

  /* this.turnoApi.find({ where: { and: [{ idSector: 2 }, { idEstado: 0 }] } })
    .subscribe((respuesta: any) => {
      console.log(respuesta)
      respuesta.forEach(element => {
        element.dni = element.dni.slice(-4)
      });
      this.turnosContactologiaDB = respuesta;
    })*/

  // 0-En espera, 1-Atendido, 2-Ausente, 3-Cancelado,4-Finalizado

  volver() {
    this.router.navigateByUrl('display-cliente')
  }
  async filtrarTurnos() {

    this.listaPreguntas = [];
    this.listaEncuestas = [];


    

    if (!this.tipoEncuestaSeleccionada || !this.fechaDesde || !this.fechaHasta) {
      this.toastr.error('Debe seleccionar una encuesta y definir el rango de fechas.');
      return;
    }
    debugger;
    const fechaDesde = `${this.fechaDesde} 00:00:00`;
    const fechaHasta = `${this.fechaHasta} 23:59:59`;

    console.log('Fecha Desde:', fechaDesde);
    console.log('Fecha Hasta:', fechaHasta);

    this.spinner.show();

    let formularioCampos = await this.consultaSql.GetStoreDinamic({
      nombreStore: "GetCampoFormularioEncuesta",
      data:{
        ENCUESTAFILTRO: this.tipoEncuestaSeleccionada
      }
    }).toPromise();

    let filtro: any = {
      where: {
        and: [
          { encuestaId: this.tipoEncuestaSeleccionada },
          { fechaHora: { gte: fechaDesde } },
          { fechaHora: { lte: fechaHasta } }
        ]
      },
      include: [
        {
          relation: 'detalles',
          scope: {
            include: [
              {
                relation: 'pregunta',
                scope: {
                  where: { 'tipoPregunta.generaRespuesta': { inq: [1, 2] } },
                  include: [{ relation: 'tipoPregunta' }]
                }
              }
            ]
          }
        }, { relation: 'sucursal' }
      ]
    };

    if (this.idsucursalseleccionada != 0) {
      filtro.where.and.push({ sucursalId: this.idsucursalseleccionada })
    }


  let datos = await  this.consultaSql.GetStoreDinamic({
      nombreStore: "GetRespuestasFormulario",
      data:{
        IDFORMULARIOFILTRO: 1
      }
    })
    .toPromise();

    

    this.encuestRespuestaApi.find(filtro).subscribe((respuestas: any[]) => {
      console.log('Respuestas obtenidas:', respuestas);

      this.listaPreguntas = [];
      for (const respuesta of respuestas) {
        for (const detalle of respuesta.detalles) {
          if (
            detalle.pregunta &&
            detalle.pregunta.tipoPregunta &&
            (detalle.pregunta.tipoPregunta.generaRespuesta === 1 || detalle.pregunta.tipoPregunta.generaRespuesta === 2)
          ) {
            const textoLimpio = this.limpiarTexto(detalle.pregunta.texto);
            if (!this.listaPreguntas.some(p => p.id === detalle.pregunta.id)) {
              detalle.pregunta.texto = textoLimpio;
              this.listaPreguntas.push(detalle.pregunta);
            }
          }
        };
      };

      //FORMULARIO SE AGREGA COMO PREGUNTAS PARA PODER MOSTRARLO DE MANERA HORIZONTAL COMO CAMPOS
      for (const respuesta of datos[0]) {
          let elemento = respuestas.filter(x=> x.id == respuesta.encuesta_respuesta_id)
          if (elemento.length > 0){
            elemento[0].detalles.push({
              pregunta:{
                texto: respuesta.nombre_campo,
                id: respuesta.campo_id.toString() + 'form'
              },
              respuesta : respuesta.valor,
              formulario : true
            })
          }
      };
      
      formularioCampos[0].forEach(element => {
        this.listaPreguntas.push({
          "encuestaId": 1,
          "id": element.id + "form",
          "texto": element.leyenda,
          
        })
      });
   


      console.log("RESPUESTA FINAL ", respuestas)
      // Validar si no hay preguntas
      if (this.listaPreguntas.length === 0) {
        this.toastr.error('No hay preguntas asociadas a esta encuesta. La tabla no se mostrará.');
        this.spinner.hide();
        return;
      }

      console.log("*********LLISTA PREGUNTAS ",  this.listaPreguntas)
      // Construir tabla dinámica
      this.listaEncuestas = respuestas.map(respuesta => {

        const fechaOriginal = new Date(respuesta.fechaHora);
        const offset = +3; // UTC-3
        let fecha = new Date(fechaOriginal.getTime() + offset * 60 * 60 * 1000);
        const fila: any = {

          fechaHora: fecha//respuesta.fechaHora//.split(' ')[0] // Solo mostrar la fecha sin la hora
        };
        fila.sucursal = respuesta.sucursal.nombre;
        this.listaPreguntas.forEach(pregunta => {
          const detalle = respuesta.detalles.find(d => d.pregunta.id === pregunta.id);
          fila[pregunta.texto] = detalle ? detalle.respuesta : '-';

          const detalleFormulario = respuesta.detalles.find(d => d.pregunta.id === pregunta.id);
          fila[pregunta.texto] = detalleFormulario ? detalleFormulario.respuesta : '-';

       
        });
        return fila;
      });

      console.log('Lista final de Preguntas:', this.listaPreguntas);
      console.log('Lista final de Encuestas:', this.listaEncuestas);

      this.spinner.hide();
    });
  }







  // Función para limpiar caracteres especiales de un texto
  private limpiarTexto(texto: string): string {
    return texto
      .replace(/<\/?[^>]+(>|$)/g, '') // Elimina etiquetas HTML
      .replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s/]/g, '') // Permite el carácter '/'
      .trim(); // Elimina espacios extra al inicio y al final
  }


  verEncuestas() {

  }
  exportarAExcel(): void {
    const aux: any[] = [];

    // Generar encabezados dinámicos
    const encabezados: string[] = ['Fecha/Hora', ...this.listaPreguntas.map(p => p.texto)];

    // Construir filas con los datos de listaEncuestas
    this.listaEncuestas.forEach(respuesta => {
      const fechaOriginal = new Date(respuesta.fechaHora);
      const offset = +3; // UTC-3
      let fecha = new Date(fechaOriginal.getTime() + offset * 60 * 60 * 1000);
      const fila: any = {

        fechaHora: fecha//respuesta.fechaHora//.split(' ')[0] // Solo mostrar la fecha sin la hora
      };
      fila.sucursal = respuesta.sucursal.nombre;
      // Agregar respuestas dinámicamente basadas en las preguntas
      this.listaPreguntas.forEach(pregunta => {
        fila[pregunta.texto] = respuesta[pregunta.texto] || '-'; // Respuesta o valor por defecto
      });

      aux.push(fila); // Añadir la fila al array auxiliar
    });

    // Crear el archivo Excel
    const wb: XLSX.WorkBook = XLSX.utils.book_new(); // Crear nuevo libro
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(aux, { header: encabezados }); // Crear hoja con encabezados
    XLSX.utils.book_append_sheet(wb, ws, 'Encuestas'); // Añadir hoja al libro
    const nombreArchivo = 'encuestas.xlsx'; // Nombre del archivo

    // Guardar el archivo Excel
    XLSX.writeFile(wb, nombreArchivo, { bookType: 'xlsx' });
  }


}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/listado-encuestas/listado-encuestas.component.ts